// Imports
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";

// UI Imports
import AppBar from '@mui/material/AppBar';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@mui/material/Button";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Popover, List, ListItem, ListItemText, Badge } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CloseIcon from '@mui/icons-material/Close';
import styles from "./styles";
import Stack from "@mui/material/Stack";

// App Imports
import routes from "../../../setup/routes";
import params from "../../../setup/config/params";
import { messageShow } from "../api/actions";
import { logout ,listVendors } from "../../user/api/actions/query";
import { grey } from "@mui/material/colors";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import { IMAGE_SOURCE_PATH } from "../../../setup/config/env";
import { defaultImage, logo } from "../Sidebar";
import { settingDetail } from "../../setting/api/actions/query";
function getImageSource(image=defaultImage) {
  return `${IMAGE_SOURCE_PATH}${image}`;
}
let vendorData = [];
// Component
class Header extends PureComponent {
  state = {
    anchorEl: null,
    vendors: [],
    notificationAnchor: null,
    notifications: JSON.parse(localStorage.getItem("notifications")) || [],
    currencySymbol: "" 
  };
  componentDidMount() {
    const { isAuthenticated } = this.props.auth;
    if (isAuthenticated){
      this.fetchVendors() 
      this.fetchSettings();
    } 
    window.headerComponentInstance = this;
  }

  componentWillUnmount() {
    window.headerComponentInstance = null;
  }

  fetchVendors = async () => {
    const { listVendors } = this.props;
    try {
      const { data } = await listVendors({ page:1 });
      // console.log("Vendor: ", data)
      if (data.success) {
        vendorData = data.data.list; 
        this.setState({ vendors: vendorData });
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };
  
  fetchSettings = async () => {
    const { settingDetail } = this.props;
    try {
      const { data } = await settingDetail();
      if (data.success && data.data.currencyData) {
        const currencySymbol = data.data.currencyData.symbol;
        this.setState({ currencySymbol });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleNotificationClick = (event) => {
    this.setState({ notificationAnchor: event.currentTarget });
  };
  
  handleNotificationClose = () => {
    this.setState({ notificationAnchor: null, notifications: [] });
    localStorage.removeItem("notifications");
  };  

  onClickLogout = () => {
    let check = window.confirm("Are you sure you want to logout?");

    if (check) {
      const { logout, messageShow, history } = this.props;

      logout();

      messageShow("You have been logged out successfully.");

      history.push(routes.userLogin.path);
    }
    this.handleClose();
  };

  homeLink = () => {
    const {
      auth: { isAuthenticated },
    } = this.props;
    return isAuthenticated ? routes.userDashboard.path : routes.userLogin.path;
  };

  render() {
    const {
      classes,
      auth: { isAuthenticated, user },
    } = this.props;
    const { anchorEl, vendors,  notifications, notificationAnchor, currencySymbol } = this.state;
    const siteName = vendors.length > 0 ? vendors[0].name: ""

    return (
      <div className={classes.root}>
        <AppBar 
          position="fixed" 
          elevation={2} 
          sx={{ 
            backgroundColor: "#0d3559 !important",
            "&.MuiAppBar-root": {
              backgroundColor: "#0d3559 !important"
            },
            "&": {
              backgroundColor: "#0d3559 !important"
            }
          }}
          style={{ backgroundColor: "#0d3559" }}
        >
          <Toolbar style={{ backgroundColor: "#0d3559" }}>
            <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
              <img
                src={getImageSource(localStorage.getItem("logo"))}
                style={{ 
                  width: "auto",
                  height: "40px",
                  objectFit: "contain",
                  borderRadius:0,
                }}
              />
            </Link>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.flex}
              style={{ color: "white", marginLeft:"10px" }}
            >
              <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
                <font size={4} style={{ cursor: 'pointer' }}>
                  {siteName} Store Console
                </font>
              </Link>
            </Typography>


            {isAuthenticated ? (
              <Stack direction="row" spacing={3} alignItems="center">
                <IconButton color="inherit" onClick={this.handleNotificationClick}>
                  <Badge
                    badgeContent={notifications.length}
                    sx={{
                      '& .MuiBadge-badge': {
                        backgroundColor: '#ffffff',
                        color: '#040404ff',
                        fontSize: '0.75rem',
                        minWidth: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        padding: '0 4px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                      }
                    }}
                  >
                    <NotificationsIcon sx={{ color: "rgb(237,108,2)" }} />
                  </Badge>
                </IconButton>

                <Popover
                  open={Boolean(notificationAnchor)}
                  anchorEl={notificationAnchor}
                  onClose={this.handleNotificationClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  {notifications.length > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px", borderBottom: "1px solid #ddd" }}>
                      <Typography variant="subtitle1" style={{ fontWeight: 500 }}>Notifications</Typography>
                      <IconButton onClick={this.handleNotificationClose}>
                        <CloseIcon style={{ color: '#000', fontSize: '20px' }} />
                      </IconButton>
                    </div>
                  )}
                  <List>
                    {notifications.length > 0 ? (
                      [...notifications].reverse().map((notif, index) => {
                        let primaryText = "";
                        let secondaryText = "";

                        switch (notif.event) {
                          case "table.reserved":
                            primaryText = `New Reservation: ${notif.payload.name} has booked a table for ${notif.payload.persons} guests.`;
                            secondaryText = `Time Slot: ${notif.payload.timeSlot}`;
                            break;
                          case "order.created":
                            primaryText = `New Order: ${notif.payload.userDetails.name} has placed a order (ID: ${notif.payload.id})`;
                            secondaryText = `Total Amount: ${currencySymbol} ${notif.payload.grandTotal} `;
                            break;
                          case "qr-order.updated":
                            primaryText = `Update Order: ${notif.payload.table.tableName} has updated order (ID: ${notif.payload.orderId})`;
                            secondaryText = `Total Amount: ${currencySymbol} ${notif.payload.grandTotal} `;
                            break;
                          case "email.campaign.completed":
                            primaryText = `Email Notification`
                            secondaryText = `Event: ${notif.payload.eventName} is ${notif.payload.status}`;
                        }

                        return (
                          <ListItem key={index} divider>
                            <ListItemText primary={primaryText} secondary={secondaryText} />
                          </ListItem>
                        );
                      })
                    ) : (
                      <ListItem>
                        <ListItemText primary="No new notifications" />
                      </ListItem>
                    )}
                  </List>

                </Popover>
                <Avatar
                  src={getImageSource(user?.image)}
                  alt={user?.name}
                  onClick={this.handleClick}
                  sx={{
                    cursor: "pointer",
                    width: 40,
                    height: 40,
                  }}
                />
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      backgroundColor: "#0d3559 !important",
                      minWidth: "150px",
                      "&.MuiPaper-root": {
                        backgroundColor: "#0d3559 !important"
                      },
                      "& .MuiList-root": {
                        backgroundColor: "#0d3559 !important"
                      },
                      "& .MuiMenuItem-root": {
                        color: "white",
                        paddingY: "12px",
                        paddingX: "16px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        backgroundColor: "#0d3559 !important",
                        "&:hover": {
                          backgroundColor: "#0d3559 !important",
                          color: "#ff7614"
                        }
                      },
                      "& .MuiMenuItem-root:last-child": {
                        "&:hover": {
                          backgroundColor: "#ff7614 !important",
                          color: "white"
                        }
                      }
                    },
                    style: { backgroundColor: "#0d3559" }
                  }}
                >
                  <MenuItem
                    component={Link}
                    to={routes.userProfile.path}
                    onClick={this.handleClose}
                  >
                    Profile
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to={routes.pagesContact.path}
                    onClick={this.handleClose}
                  >
                    Contact
                  </MenuItem>
                  <MenuItem
                    onClick={this.onClickLogout}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Stack>
            ) : (
              <>
                <Button
                  component={Link}
                  to={routes.userSignup.path}
                  style={{ color: "white" }}
                >
                  Signup
                </Button>
              </>
            )}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  listVendors: PropTypes.func.isRequired,
  settingDetail: PropTypes.func.isRequired
};

function headerState(state) {
  return {
    auth: state.auth,
  };
}

export default withRouter(
  connect(headerState, { logout, messageShow, listVendors, settingDetail })(withStyles(styles)(Header))
);

export { vendorData };